"use strict";

module.exports = function parseLetterpressInvitationSamples(transaction) {
  var quantity = transaction.quantity;
  this.paidLetterpressInvitationSamples.add({
    quantity: quantity
  });
};